import React from 'react';
import {Translate} from "react-localize-redux";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import LanguageSelector from '../selectors/language-selector';
import {Col, Container, Row} from 'reactstrap';

import {faFacebook, faTwitter, faInstagram} from '@fortawesome/free-brands-svg-icons';
import ModalChildrenPolicy from '../modals/modal-child-policy';
import ModalTerms from '../modals/modal-terms';

class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            companyName: "Genial Skills",
            link1: "https://www.genialskills.com",
            link2: "http://www.edulabpr.com",
            link3: "http://www.google-play.com",
            link4: "http://www.appstore.com",
            linkFacebook: "https://www.facebook.com/genialskills",
            linkTwitter: "https://www.twitter.com/genialskills",
            linkInstagram: "https://www.instagram.com/genialskills",
            showModalTerms: false,
            showModalChildrensPolicy: false
        };

        this.toggleModalTerms = this.toggleModalTerms.bind(this);
        this.toggleModalChildrenPolicy = this.toggleModalChildrenPolicy.bind(this);
    }

    /**
     * Toggle the terms modal
     */
    toggleModalTerms() {
        this.setState({showModalTerms: !this.state.showModalTerms});
    }

    /**
     * Toggle de modal children policy
     */
    toggleModalChildrenPolicy() {
        this.setState({showModalChildrensPolicy: !this.state.showModalChildrensPolicy});
    }

    render() {
        return (
            <div>
                <div className="footer-br margin-top-mandatory-60 pt-4 mt-4"></div>
                <div className="page-footer font-small pt-4 card-dark-blue">
                <Container fluid className="text-center text-md-left">
                    <Row>
                        <Col md="12">
                            {/*<ScrollToTop showUnder={0}>
                                <span className="btn card-orange"><Translate id="footer.back-to-top"/></span>
                            </ScrollToTop>*/}
                        </Col>
                        <hr className="clearfix w-100 d-md-none"/>
                        <Col md="12" className="text-center">
                            <h5 className="text-uppercase mb-4 mt-3 font-weight-bold">
                                <Translate id="footer.more-about-us"/>
                            </h5>
                            <ul className="list-unstyled">
                                <li><a href={this.state.link1} className="white-text"><Translate id="footer.store"/></a>
                                </li>
                                <li><a href={this.state.link2} className="white-text"><Translate
                                    id="footer.edulab"/></a></li>
                                <li><Translate id="footer.google-play"/></li>
                                <li><Translate id="footer.app-store"/></li>
                                {/*<li><a href={this.state.link3} className="white-text"><Translate
                                    id="footer.google-play"/></a></li>
                                <li><a href={this.state.link2} className="white-text"><Translate id="footer.app-store"/></a>
                                </li>*/}
                            </ul>
                        </Col>
                    </Row>
                </Container>
                <hr/>
                <div className="text-center py-3">
                    <LanguageSelector/>
                </div>
                <div className="footer-bottom-background-color">
                    <hr className="hr-dark"/>
                    <div className="text-center">
                        <ul className="list-unstyled list-inline">
                            <li className="list-inline-item">
                                <a href={this.state.linkFacebook} className="white-text">
                                    <FontAwesomeIcon icon={faFacebook} size="2x"/>
                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href={this.state.linkTwitter} className="white-text">
                                    <FontAwesomeIcon icon={faTwitter} size="2x"/>
                                </a>
                            </li>
                            <li className="list-inline-item">
                                <a href={this.state.linkInstagram} className="white-text">
                                    <FontAwesomeIcon icon={faInstagram} size="2x"/>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-copyright text-center py-3">
                        <Container fluid>
                            <ModalTerms isOpen={this.state.showModalTerms} toggle={this.toggleModalTerms}/>
                            <ModalChildrenPolicy isOpen={this.state.showModalChildrensPolicy}
                                                 toggle={this.toggleModalChildrenPolicy}/>
                            <br/>
                            &copy; {(new Date().getFullYear())} {' '}
                            <Translate id="footer.copyright" options={{renderInnerHtml: false}}/>
                            {' '} {this.state.companyName}
                        </Container>
                    </div>
                </div>
            </div>
                </div>
        );
    }
}

export default Footer;